import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useLongPress } from '@uidotdev/usehooks';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { MessageActions } from '..';
import { ElementPosition, MessageStatus, } from '../types/curbTypes';
import { formatTimeAgo } from '../utils';
import { POPUP_POSITION_SWITCH_HEIGHT } from './AutocompleteList';
import { Avatar } from './Avatar';
import DeletedMessage from './DeletedMessage';
import MessageSendingIcon from './Icons/MessageSendingIcon';
import MessageSentIcon from './Icons/MessageSentIcon';
import MessageEditor from './MessageEditor';
import MessageEditorMobile from './MessageEditorMobile';
import MessageFileField from './MessageFileField';
import MessageImageField from './MessageImageField';
import MessageReactionsField from './MessageReactionsField';
import RenderHtml from './RenderHtml';
import ReplyContainerButton from './ReplyContainerButton';
const ActionsContainer = styled.div `
  position: absolute;
  z-index: 30;
  top: 0rem;
  right: 1rem;
  visibility: hidden;
  opacity: 0;
`;
const ActionsContainerMobile = styled.div `
  display: none;
  @media (max-width: 1024px) {
    display: flex;
    position: absolute;
    z-index: 30;
    top: ${({ $addPadding }) => ($addPadding ? '-1rem' : '0rem')};
    right: 1rem;
  }
`;
const MessageContainer = styled.div `
  width: 100%;
  border-radius: 4px;
  box-sizing: border-box;
  padding-top: 6px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  @media (max-width: 1024px) {
    max-width: 1024px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    padding-left: 14px;
    padding-right: 14px;
  }
  ${({ $editmode }) => $editmode && 'background-color: #0A131E;'}
  @media (min-width: 1025px) {
    &:hover ${ActionsContainer} {
      visibility: visible;
      ${({ $editmode }) => !$editmode && 'opacity: 1;'}
    }
    &:hover {
      ${({ $editmode }) => !$editmode && 'background-color: #1e1e1e;'}
    }
  }
`;
const SenderInfoContainer = styled.div `
  width: 100%;
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
  display: flex;
  justify-content: flex-start;
`;
const ProfileIconContainerMsg = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  ${({ id }) => id && `background-color: #111;`}
  text-align: center;
  /* Body/Small */
  font-family: Helvetica Neue;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 18px */
`;
const NameContainerSender = styled.div `
  display: flex;
  justify-content: start;
  align-items: center;
  width: 100%;
  color: #6c757d;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
`;
const MessageText = styled.div `
  flex-grow: 1;
  flex-shrink: 1;
  overflow: hidden;
  word-wrap: break-word;
  padding-top: 0px;
  padding-left: 2rem;
  padding-right: 2rem;
  color: #fff;
  font-family: Helvetica Neue;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  -webkit-font-smoothing: antialiased applied;

  @media (max-width: 1024px) {
    font-size: 12px;
    padding-right: 0;
  }

  background-color: ${(props) => props.$globalMention && '#ecfc910d'};

  .mention-everyone,
  .mention-here {
    background-color: #ecfc910d !important;
    color: #73b30c !important;
  }

  .mention-user-${(props) => props.$accountId && `${props.$accountId}`} {
    color: #73b30c !important;
    background-color: #ecfc910d !important;
  }

  .mention {
    background-color: #73b30c;
  }

  .msg-content p {
    margin: 0 0 6px 0;
  }
  .msg-content ul,
  .msg-content ol {
    margin: 4px 0 6px 16px;
  }
  .msg-content li {
    margin: 2px 0;
  }
  .msg-content code {
    background: #1e1e1e;
    padding: 1px 4px;
    border-radius: 4px;
  }
  .msg-content pre {
    background: #111;
    padding: 8px;
    border-radius: 6px;
    overflow: auto;
  }
  .msg-content blockquote {
    margin: 6px 0;
    padding: 6px 10px;
    border-left: 3px solid #a5ff11;
    background: #111;
  }

  /* URL Link Styles */
  a,
  .url-link,
  .rich-text-link {
    cursor: pointer;
    text-decoration: none;
    color: #4e95ff;
    word-break: break-all;
  }

  a:hover,
  .url-link:hover,
  .rich-text-link:hover {
    color: #74abff;
    text-decoration: underline;
  }

  a:visited,
  .url-link:visited,
  .rich-text-link:visited {
    color: #4e95ff;
  }
  span {
    color: #fff !important;
  }
`;
const Tick = styled.div `
  padding-right: 2rem;
  width: 24px
  text-align: right;
  align-self: flex-end;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  color: #777583;
  font-family: Helvetica Neue;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;
const MessageContentContainer = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const MessageTime = styled.div `
  padding-right: 2rem;
  color: #777583;
  font-family: Helvetica Neue;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  @media (max-width: 1024px) {
    bottom: -1rem;
    right: 4px;
  }
`;
const FullScreenWrapper = styled.div `
  @media (min-width: 1025px) {
    display: none;
  }
  @media (max-width: 1024px) {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 20;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
`;
const ClosableBackground = styled.div `
  width: 100%;
  height: 100%;
  pointer-events: auto;
`;
const shouldShowHeader = (message, prevMessage) => {
    if (!prevMessage)
        return true; // No previous message
    if (prevMessage.sender !== message.sender)
        return true; // Different sender
    if ((prevMessage.files.length === 0 &&
        prevMessage.images.length === 0 &&
        !prevMessage.text &&
        prevMessage.editedOn) ||
        prevMessage.deleted)
        return true;
    return message.timestamp - prevMessage.timestamp >= 300000; // 5 minutes or more between messages
};
const Message = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const text = props.message.text;
    const [screenSize, setScreenSize] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [isMessageRectionListVisible, setIsMessageReactionListVisible] = useState(false);
    const [isMoreActionVisible, setIsMoreActionVisible] = useState(false);
    const [popupPosition, setPopupPosition] = useState(ElementPosition.TOP);
    const [selectedReaction, setSelectedReaction] = useState(undefined);
    function openMessageReactionsList(reaction) {
        setIsMessageReactionListVisible(true);
        setSelectedReaction(reaction);
    }
    function closeMessageReactionsList() {
        setIsMessageReactionListVisible(false);
        setSelectedReaction(undefined);
    }
    const attrs = useLongPress(() => {
        setIsOpen(!isOpen);
        props.setOpenMobileReactions(props.message.id);
    });
    if ((props.message.files.length === 0 &&
        props.message.images.length === 0 &&
        !props.message.text &&
        props.message.editedOn) ||
        props.message.deleted) {
        return _jsx(DeletedMessage, {});
    }
    function messageStatus(status) {
        return status === MessageStatus.sending ? (_jsx(MessageSendingIcon, {})) : (_jsx(MessageSentIcon, {}));
    }
    useEffect(() => {
        if (window) {
            setScreenSize(window.innerWidth);
        }
    }, [window]);
    useEffect(() => {
        const container = document.getElementById(`actions-container-${props.message.id}`);
        if (container) {
            const containerPositions = container.getBoundingClientRect();
            if (containerPositions.top < POPUP_POSITION_SWITCH_HEIGHT) {
                setPopupPosition(ElementPosition.BOTTOM);
            }
            else {
                setPopupPosition(ElementPosition.TOP);
            }
        }
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs(MessageContainer, Object.assign({}, attrs, { "$editmode": ((_a = props.message) === null || _a === void 0 ? void 0 : _a.editMode) ? true : false }, { children: [_jsx(ActionsContainer, Object.assign({ id: `actions-container-${props.message.id}` }, { children: _jsx(MessageActions, { editable: props.editable, deletable: props.deletable, toggleReaction: props.handleReaction, setThread: props.openThread, toggleEmojiSelector: props.toggleEmojiSelector, editMessage: props.editMessage, deleteMessage: props.deleteMessage, openMessageReactionsList: () => openMessageReactionsList(undefined), isThread: props.isThread, isMoreActionVisible: isMoreActionVisible, setIsMoreActionVisible: setIsMoreActionVisible, popupPosition: popupPosition }) })), isOpen && props.openMobileReactions === props.message.id && (_jsx(FullScreenWrapper, { children: _jsx(ClosableBackground, { onClick: () => {
                                setIsOpen(false);
                                props.setOpenMobileReactions('');
                            } }) })), isOpen && props.openMobileReactions === props.message.id && (_jsx(ActionsContainerMobile, Object.assign({ "$addPadding": !shouldShowHeader(props.message, props.prevMessage), id: `actions-container-${props.message.id}` }, { children: _jsx(MessageActions, { editable: props.editable, deletable: props.deletable, toggleReaction: (emoji) => {
                                props.handleReaction(emoji);
                                setIsOpen(false);
                            }, setThread: props.openThread, toggleEmojiSelector: props.toggleEmojiSelector, editMessage: props.editMessage, deleteMessage: props.deleteMessage, openMessageReactionsList: () => openMessageReactionsList(undefined), isThread: props.isThread, isMoreActionVisible: isMoreActionVisible, setIsMoreActionVisible: setIsMoreActionVisible, popupPosition: popupPosition }) }))), shouldShowHeader(props.message, props.prevMessage) && (_jsxs(SenderInfoContainer, { children: [_jsx(ProfileIconContainerMsg, { children: _jsx(Avatar, { size: "sm", name: props.message.senderUsername }) }), _jsx(NameContainerSender, { children: props.message.senderUsername }), _jsx(MessageTime, { children: formatTimeAgo(props.message.timestamp / 1000, false) })] })), ((_c = (((_b = props.message) === null || _b === void 0 ? void 0 : _b.editMode) && screenSize > 1024)) !== null && _c !== void 0 ? _c : false) ? (_jsx(MessageEditor, { text: text, onSubmit: props.submitEditedMessage, onCancelEdit: props.cancelEditMessage, deleteMessage: props.deleteMessage, getIconFromCache: props.getIconFromCache, fetchAccounts: props.fetchAccounts, autocompleteAccounts: props.autocompleteAccounts })) : (_jsxs(MessageContentContainer, { children: [_jsx(MessageText, Object.assign({ "$globalMention": (text === null || text === void 0 ? void 0 : text.includes('mention-everyone')) ||
                                    (text === null || text === void 0 ? void 0 : text.includes('mention-here')) ||
                                    (text === null || text === void 0 ? void 0 : text.includes(`mention-user-${props.accountId}`)), "$accountId": props.accountId
                                    .replace(/\./g, '\\.')
                                    .replace(/_/g, '\\_') }, { children: _jsx(RenderHtml, { html: text }) })), _jsxs(Tick, { children: [props.message.editedOn && '(edited) ', messageStatus(props.message.status)] })] })), props.message.images.length > 0 && (_jsx(MessageImageField, { images: props.message.images, encryptionKey: props.message.key, nonce: props.message.nonce, authToken: props.authToken, privateIpfsEndpoint: props.privateIpfsEndpoint })), props.message.files.length > 0 && (_jsx("div", Object.assign({ style: { paddingTop: !!text ? '8px' : '0px' } }, { children: _jsx(MessageFileField, { files: props.message.files, encryptionKey: props.message.key, nonce: props.message.nonce, authToken: props.authToken, privateIpfsEndpoint: props.privateIpfsEndpoint }) }))), props.message.reactions && (_jsx(MessageReactionsField, { reactions: props.message.reactions, accountId: props.accountId, handleReaction: props.handleReaction, getIconFromCache: props.getIconFromCache, selectedReaction: selectedReaction, openMessageReactionsList: openMessageReactionsList, closeMessageReactionsList: closeMessageReactionsList, isMessageRectionListVisible: isMessageRectionListVisible }))] })), !props.isThread && (props.message.threadCount || 0) > 0 && (_jsx(ReplyContainerButton, { replyCount: (_d = props.message.threadCount) !== null && _d !== void 0 ? _d : 0, lastTimestamp: ((_e = props.message.threadLastTimestamp) !== null && _e !== void 0 ? _e : 0) / 1000, onClick: () => {
                    props.openThread();
                } })), ((_f = props.message) === null || _f === void 0 ? void 0 : _f.editMode) && screenSize < 1025 && (_jsx(MessageEditorMobile, { text: text, onSubmit: props.submitEditedMessage, onCancelEdit: props.cancelEditMessage, deleteMessage: props.deleteMessage, getIconFromCache: props.getIconFromCache, fetchAccounts: props.fetchAccounts, autocompleteAccounts: props.autocompleteAccounts }))] }));
};
export default Message;
